<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.5 7.5V8.5H5.87612V7.5H0.5Z" fill="black" />
    <path d="M5.31194 7.5V8.5H10.6881V7.5H5.31194Z" fill="black" />
    <path d="M10.1239 7.5V8.5H15.5V7.5H10.1239Z" fill="black" />
    <path
      d="M7.5 15.5L8.5 15.5L8.5 10.1239L7.5 10.1239L7.5 15.5Z"
      fill="black"
    />
    <path
      d="M7.5 10.6881L8.5 10.6881L8.5 5.31194L7.5 5.31194L7.5 10.6881Z"
      fill="black"
    />
    <path
      d="M7.5 5.87612L8.5 5.87612L8.5 0.500001L7.5 0.500001L7.5 5.87612Z"
      fill="black"
    />
  </svg>
</template>